export const frequencyOptions = [
  '1 month',
  '2 months',
  '3 months',
  '4 months',
  '6 months',
  '1 year'
];

export const discount = [
  '0%',
  '5%',
  '10%',
  '15%',
  '20%',
  '25%'
];

export const emptySubscription = (id) => ({
  product_id: id,
  frequency_count: '',
  frequency_unit: '',
  sproduct_label: '',
  installment_price: '',
  additional_information: '',
  ssort_order: ''
});
